/**
 * dirty判定用にデータを正規化する
 *
 * - validationTriggered など比較不要なキーを除外
 * - 入力後に "" になりがちな値を null に統一
 *   （初期値 null と、削除後の "" を同一視するため）
 */
export const normalizeForDirty = (data) => {
  if (!data) return data;

  const clone = { ...data };

  // dirty判定に不要なフラグは除外
  delete clone.validationTriggered;

  Object.keys(clone).forEach((key) => {
    const value = clone[key];

    // 配列・オブジェクトはここでは触らない
    if (Array.isArray(value) || (value && typeof value === "object")) return;

    // 空文字と null を同一視するため null に寄せる
    if (value === "") clone[key] = null;
  });

  return clone;
};
